import Icon from '../components/Icon.vue'

Icon.register({"sticky-note":{"width":1536,"height":1792,"paths":[{"d":"M1024 1248v416h-928q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h1344q40 0 68 28t28 68v928h-416q-40 0-68 28t-28 68zM1152 1280h381q-15 82-65 132l-184 184q-50 50-132 65v-381z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sticky-note.js
// module id = 4KSB
// module chunks = 0